import axios from "axios";
import { getBaseURL } from "../features/auth/utils/authStorage";
import { getSessionValue, clearSession } from "../security/session";

const API_BASE_URL = getBaseURL();

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
});

api.interceptors.request.use(
  (config) => {
    const token = getSessionValue("token") || getSessionValue("authToken") || getSessionValue("knoxToken");

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const responseData = error?.response?.data || {};
    const apiError = responseData.error;
    const isHtmlErrorPage =
      typeof responseData === "string" &&
      /<!DOCTYPE html>|<html[\s>]|<body[\s>]|Page not found/i.test(responseData);

    if (apiError?.message) {
      error.message = apiError.message;
      error.details = apiError.details;
      error.code = apiError.code;
    } else if (isHtmlErrorPage) {
      if (error?.response?.status === 404) {
        error.message = "Endpoint não encontrado no backend ativo. Reinicie o MPS_API para carregar as rotas novas.";
      } else {
        error.message = "O backend devolveu uma página HTML inesperada em vez de JSON.";
      }
    } else if (typeof responseData.detail === "string" && responseData.detail.trim()) {
      error.message = responseData.detail;
      error.details = responseData.details;
      error.code = responseData.code;
    } else if (typeof responseData.message === "string" && responseData.message.trim()) {
      error.message = responseData.message;
      error.details = responseData.details;
      error.code = responseData.code;
    }

    if (error?.response?.status === 401) {
      clearSession();
    }
    return Promise.reject(error);
  }
);

export async function apiBlob(path, { params, method = "get", data } = {}) {
  return api.request({
    url: path,
    method,
    params,
    data,
    responseType: "blob",
  });
}
